import { Grid } from '@chakra-ui/react';
import Pharmacy from '../types/Pharmacy';
import Prescriptions from '../types/Prescriptions';

const PdpColumns = ({ prescriptions, onFilterChange, pharmacy }) => {
  return (
    <Grid
      templateColumns={['repeat(1, 1fr)', 'repeat(1, 1fr)', 'repeat(2, 1fr)', 'repeat(2, 1fr)']}
      minH="240px"
      columnGap={[4, 4, 4, 8]}
      overflow="hidden"
      sx={{
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        flex: 'wrap',
        ' > div': {
          flex: '1 !important',
        },
      }}
      flexWrap="wrap"
    >
      <Prescriptions prescriptions={prescriptions} onFilterChange={onFilterChange} />
      <Pharmacy pharmacy={pharmacy} />
    </Grid>
  );
};

export default PdpColumns;
